enum UIVariant {
  PRIMARY = 'primary',
  DARK = 'dark',
  LIGHT = 'light',
  REVERSED_PRIMARY = 'reversed-primary',
  GREEN = 'green',
  REVERSED_GREEN = 'reversed-green',
  RED = 'red',
  TRANSPARENT = 'transparent',
  BLUE = 'blue',
}
export default UIVariant;
